import React from "react";

import moment from "moment";

import { Container, Row, Table, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import CancelButton from "presentation/components/buttons/cancel";

import Datetime from 'react-datetime';


import { applyPattern, getAttendaceType, goTo, handleResultData } from "presentation/utils/functions/generic";
import { itemFieldValue, handleItemChange, handleItemDateTimeChange, handleChangeAll } from "presentation/utils/functions/state-list-handler";

import classroomsService from "presentation/services/classrooms";
import eventInfosService from "presentation/services/event-infos";
import eventAttendancesService from "presentation/services/event-attendances";
import classroomsStudentsService from "presentation/services/classroom-students";
import { ATTENDANCE_TYPE_ABSENCE, ATTENDANCE_TYPE_AUTHORISED_ABSENCE, ATTENDANCE_TYPE_DELAY, ATTENDANCE_TYPE_NOT_INFORMED, ATTENDANCE_TYPE_PRESENT, ENTITY_TYPE_STUDENT } from "presentation/model/constants";

class ClassroomStudentsAttendancesMain extends React.Component {

  STATE_LIST_KEY = 'classroomAttendance';
  CHANGE_ALL_STATE_LIST_KEY = 'changeAllClassroomAttendance';
  ENTITY_PRIMARY_KEY_PATTERN = 'st-%s';
  ENTITY_SECONDARY_KEY_PATTERN = 'ei-%s';
  LIST_KEY_PATTERN = `${this.ENTITY_PRIMARY_KEY_PATTERN}|${this.ENTITY_SECONDARY_KEY_PATTERN}`;
  STRUCTURE_ITEM_KEY_PATTERN = this.ENTITY_SECONDARY_KEY_PATTERN;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      actionLoading: false,
      attendancesLoaded: false,
      error: false,
      message: '',
      students: [],
      classroom: {
        name: ''
      },
      eventInfo: {
        title: ''
      },
      batchAttendanceType: null
    };
    this.loadData = this.loadData.bind(this);
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { mountStateList, STATE_LIST_KEY, STRUCTURE_ITEM_KEY_PATTERN, CHANGE_ALL_STATE_LIST_KEY } = this;
    const { id, eventInfoId } = this.props.match.params;
    var classroom = {};
    var eventInfo = {};
    var attendances = [];
    var students = [];

    await eventAttendancesService.search({ classroomId: [id], entityType: ENTITY_TYPE_STUDENT, eventInfoId: [eventInfoId] }).then((result) => {
      let handledResult = handleResultData(result);
      attendances = handledResult;
    });

    await classroomsService.findById(id).then((result) => {
      let handledResult = handleResultData(result);
      classroom = handledResult;
    });

    await eventInfosService.findById(eventInfoId).then((result) => {
      let handledResult = handleResultData(result);
      eventInfo = handledResult;
    });

    await classroomsStudentsService.search({ classroomId: id }).then((result) => {
      let handledResult = handleResultData(result);
      students = handledResult;
    });

    var stateList = mountStateList(students, eventInfo, attendances);

    var changeAllStateList = [{ key: applyPattern(STRUCTURE_ITEM_KEY_PATTERN, eventInfoId) }];

    this.setState({ classroom, students, eventInfo, attendances, [STATE_LIST_KEY]: stateList, [CHANGE_ALL_STATE_LIST_KEY]: changeAllStateList, loading: false });
  }


  mountStateList = (students, eventInfo, attendances) => {

    const { id, eventInfoId } = this.props.match.params;
    const { LIST_KEY_PATTERN } = this;


    var stateList = students.map((e, i) => {
      let itemKey = applyPattern(LIST_KEY_PATTERN, e.student.id, eventInfoId);
      let item = { key: itemKey, entityId: e.student.id, entityType: ENTITY_TYPE_STUDENT, classroomId: id, eventInfoId: eventInfoId, referenceDate: eventInfo.startDate };
      let studentAttendance = attendances.filter(x => x.entityId == e.student.id && x.eventInfoId == eventInfoId && x.classroomId == id)[0];

      let attendaceType = ATTENDANCE_TYPE_NOT_INFORMED;

      if (studentAttendance) {
        let searchAttendance = studentAttendance.attendanceType || "";
        let attendanceTypeInfo = getAttendaceType(searchAttendance);
        attendaceType = attendanceTypeInfo ? attendanceTypeInfo.id : ATTENDANCE_TYPE_NOT_INFORMED;

        item.id = studentAttendance.id;
        item.attendanceType = attendaceType;
        item.startAt = studentAttendance.startAt;
        item.endAt = studentAttendance.endAt;
        item.observations = studentAttendance.observations;
      }

      return item;
    });

    return stateList;

  }

  handleSubmit = async () => {
    const { STATE_LIST_KEY } = this;

    let data = this.state[STATE_LIST_KEY];

    data.map(async (item, index) => {
      let rawAttendanceType = item.attendanceType || undefined;
      let attendanceType = parseInt(rawAttendanceType) == ATTENDANCE_TYPE_NOT_INFORMED ? undefined : parseInt(rawAttendanceType);


      if (attendanceType) {

        if (item.startAt) {
          item.startAt = moment(item.startAt).format();
        }

        if (item.endAt) {
          item.endAt = moment(item.endAt).format();
        }


        if (item.referenceDate) {
          item.referenceDate = moment(item.referenceDate).format();
        }

        await eventAttendancesService.save(item);
      } else {
        if (item.id) {
          await eventAttendancesService.remove(item.id);
        }
      }
    });

    goTo('/turmas', this);
  }


  render() {
    const { eventInfoId } = this.props.match.params;

    let component = this;
    const { STATE_LIST_KEY, STRUCTURE_ITEM_KEY_PATTERN, CHANGE_ALL_STATE_LIST_KEY, LIST_KEY_PATTERN, handleSubmit } = this;

    const { loading, actionLoading, error, message, students, classroom, eventInfo } = this.state;

    let batchKey = applyPattern(STRUCTURE_ITEM_KEY_PATTERN, eventInfoId);
    let batchAttendanceTypeValue = itemFieldValue(batchKey, "batchAttendanceType", CHANGE_ALL_STATE_LIST_KEY, component);

    let searchItemInput = batchKey;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && error === false && students.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
        {loading === false && (
          <Container>
            <Row>
              <h5>
                {classroom.name} / Registro de frequência por dia
              </h5>
              <Container>
                <Table className="mt-4">
                  <thead>
                    <tr>
                      <th colSpan={2}>{eventInfo.title}</th>
                      <th className="text-center">P</th>
                      <th className="text-center">A</th>
                      <th className="text-center">F</th>
                      <th className="text-center">FJ</th>
                      <th className="text-center">NI</th>
                      <th className="text-center"><small>Entrada</small></th>
                      <th className="text-center"><small>Saída</small></th>
                      <th className="text-center"><small>Observações</small></th>
                    </tr>
                    <tr>
                      <th width={"5%"}>Matrícula</th>
                      <th width={"25%"}>Nome</th>
                      <th className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="batchAttendanceType" data-field-target-name="attendanceType" value={ATTENDANCE_TYPE_PRESENT} checked={batchAttendanceTypeValue == ATTENDANCE_TYPE_PRESENT} onChange={(e) => handleChangeAll(batchKey, e, CHANGE_ALL_STATE_LIST_KEY, STATE_LIST_KEY, component, searchItemInput)} /></th>
                      <th className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="batchAttendanceType" data-field-target-name="attendanceType" value={ATTENDANCE_TYPE_DELAY} checked={batchAttendanceTypeValue == ATTENDANCE_TYPE_DELAY} onChange={(e) => handleChangeAll(batchKey, e, CHANGE_ALL_STATE_LIST_KEY, STATE_LIST_KEY, component, searchItemInput)} /></th>
                      <th className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="batchAttendanceType" data-field-target-name="attendanceType" value={ATTENDANCE_TYPE_ABSENCE} checked={batchAttendanceTypeValue == ATTENDANCE_TYPE_ABSENCE} onChange={(e) => handleChangeAll(batchKey, e, CHANGE_ALL_STATE_LIST_KEY, STATE_LIST_KEY, component, searchItemInput)} /></th>
                      <th className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="batchAttendanceType" data-field-target-name="attendanceType" value={ATTENDANCE_TYPE_AUTHORISED_ABSENCE} checked={batchAttendanceTypeValue == ATTENDANCE_TYPE_AUTHORISED_ABSENCE} onChange={(e) => handleChangeAll(batchKey, e, CHANGE_ALL_STATE_LIST_KEY, STATE_LIST_KEY, component, searchItemInput)} /></th>
                      <th className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="batchAttendanceType" data-field-target-name="attendanceType" value={ATTENDANCE_TYPE_NOT_INFORMED} checked={batchAttendanceTypeValue == ATTENDANCE_TYPE_NOT_INFORMED} onChange={(e) => handleChangeAll(batchKey, e, CHANGE_ALL_STATE_LIST_KEY, STATE_LIST_KEY, component, searchItemInput)} /></th>
                      <th className="text-center"></th>
                      <th className="text-center"></th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.length > 0 && students.map((element, index) => {
                      let itemKey = applyPattern(LIST_KEY_PATTERN, element.student.id, eventInfo.id);
                      let rawAttendanceType = itemFieldValue(itemKey, "attendanceType", STATE_LIST_KEY, component);
                      let rawStartAt = itemFieldValue(itemKey, "startAt", STATE_LIST_KEY, component);
                      let rawEndAt = itemFieldValue(itemKey, "endAt", STATE_LIST_KEY, component);
                      let observations = itemFieldValue(itemKey, "observations", STATE_LIST_KEY, component);

                      let attendanceType = rawAttendanceType || ATTENDANCE_TYPE_NOT_INFORMED;
                      let startAt = rawStartAt ? moment(rawStartAt, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm') : '';
                      let endAt = rawEndAt ? moment(rawEndAt, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm') : '';

                      return (
                        <tr key={element.id}>
                          <td>{element.student.registration}</td>
                          <td>{element.student.person.name}</td>
                          <td className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="attendanceType" value={ATTENDANCE_TYPE_PRESENT} checked={attendanceType == ATTENDANCE_TYPE_PRESENT} onChange={(e) => handleItemChange(itemKey, e, STATE_LIST_KEY, component)} /></td>
                          <td className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="attendanceType" value={ATTENDANCE_TYPE_DELAY} checked={attendanceType == ATTENDANCE_TYPE_DELAY} onChange={(e) => handleItemChange(itemKey, e, STATE_LIST_KEY, component)} /></td>
                          <td className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="attendanceType" value={ATTENDANCE_TYPE_ABSENCE} checked={attendanceType == ATTENDANCE_TYPE_ABSENCE} onChange={(e) => handleItemChange(itemKey, e, STATE_LIST_KEY, component)} /></td>
                          <td className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="attendanceType" value={ATTENDANCE_TYPE_AUTHORISED_ABSENCE} checked={attendanceType == ATTENDANCE_TYPE_AUTHORISED_ABSENCE} onChange={(e) => handleItemChange(itemKey, e, STATE_LIST_KEY, component)} /></td>
                          <td className="text-center"><Form.Check className="row-checkbox" type="radio" data-field-name="attendanceType" value={ATTENDANCE_TYPE_NOT_INFORMED} checked={attendanceType == ATTENDANCE_TYPE_NOT_INFORMED} onChange={(e) => handleItemChange(itemKey, e, STATE_LIST_KEY, component)} /></td>
                          <td className="text-center"><Datetime data-field-name="startAt" value={startAt} onChange={(dateValue) => handleItemDateTimeChange(itemKey, 'startAt', dateValue, STATE_LIST_KEY, component)} /></td>
                          <td className="text-center"><Datetime data-field-name="endAt" value={endAt} onChange={(dateValue) => handleItemDateTimeChange(itemKey, 'endAt', dateValue, STATE_LIST_KEY, component)} /></td>
                          <td className="text-center"><Form.Control as="textarea" data-field-name="observations" defaultValue={observations} onChange={(e) => handleItemChange(itemKey, e, STATE_LIST_KEY, component)} /></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Container>
              <div className="mt-3">
                <CancelButton
                  containerProps={{
                    as: Link,
                    to: `/turmas`
                  }}
                />
                <Button disabled={loading} variant="success" className="float-end" onClick={async () => await handleSubmit()}>Salvar</Button>
              </div>
            </Row>
          </Container>
        )}
      </div>
    );
  };
}

export default ClassroomStudentsAttendancesMain;
